import { makeStyles } from '@material-ui/core';

const dialogStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  basic: {
    padding: '0 !important',
    border: 'none'
  }
}));

export default dialogStyles;
